<template>
<div class="chapter">
<div class="inner_page">
<div class="sidebar">
<h1><a id="page_4"></a>A LAP WITHOUT A CAT IS</h1>
<p class="text_noindent">a lonely one. Those charming whiskered creatures can wriggle their way into your heart just as easily as they manage to squeeze into any spare cardboard box or cupboard. Oh how we adore those balls of fur—even as that fur slowly covers every item of clothing, piece of furniture, and spare surface in the household. That’s okay! The couch is pretty much just a scratch- post now anyway, so what’s a bit of hair? Once you share your home with a cat, it becomes impossible to imagine a day without one. Lounging in your laundry, taking control of your pillows, leaving gory “gifts” at your front door, typing nonsense messages on your keyboard—life would be so much duller without their eccentricities adding color to your day.</p>
<div class="wrap_small">
<p class="image"><img alt="image" src="images/f0004-01.jpg"/></p>
</div>
<p class="text_noindent">Sure, cats can be tyrants. Yes, you may have a few scratches, and it’s true that hungry morning meowing may wake you up with more frequency than your alarm clock, but those are small prices to pay for the joy we get in return. Just picture the intense, overwhelming cuteness of a cat sitting in a loaf-like position—perfection. Think of your pawed pet sweetly nuzzling you when you walk in the door at the end of the day—heavenly. Envision a basket full of fluffy kittens gazing at you sweetly, just begging to be cuddled—sublime.</p>
<div class="wrap_small">
<p class="image"><a id="page_5"></a><img alt="image" src="images/f0005-01.jpg"/></p>
</div>
<p class="text_noindent">What kind of cat has captured your heart? Is he Siamese or Scottish Fold? Siberian or Sphynx? Do you cuddle with a pint-sized Munchkin or a massive Maine Coon? Whether she’s calico or tiger, shorthair or long—if you’re holding this feline-celebrating book in your hands, you must be a cat lover.</p>
<p class="first1_noindent">When your favorite friend is a feline, your phone is bound to be overflowing with cat photos, and your Instagram account littered with kitten snapshots. So let’s take a break and gaze at some cats created in ink, paint, or pixels for a change. <em>Here Kitty Kitty</em> is like catnip for kitty caretakers. Each charming illustration in the volume will make a cat lady (or gent) purr like a kitten that has found the perfect sunny spot to bask in. With each turn of the page, you’ll find artwork by an illustrator who can capture the eloquence of a tail twitch or appreciates the feeling of getting your legs licked after you get out of the shower.</p>
<p class="first1_noindent">These quirky and charming illustrations both capture the delightful (yet sometimes peculiar) realities of cat ownership (the bed hogging, the aloofness, the yarn predilection) and also showcase our furry friends in more fantastical ways (cupcake cats, cats riding bikes, kitties frolicking with tigers, cats wearing pajamas). Alongside these delightful depictions, we’ve sprinkled an array of quotations from a selection of cat-loving famous folks. The words beautifully articulate what the artists convey in images: a deep appreciation for the mysterious, meowing, yowling cats we cherish so deeply.</p>
<p class="first1_noindent">So grab the constantly snoozing object of your affection and cuddle up on that hair-covered couch. Give your beloved pet a bit of a chin-scratch and turn your attention to this heart-warming collection of quirky, witty, cranky, lovable kitties.</p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_6"></a><a id="page_7"></a><img alt="image" class="horizontal" src="images/f0007-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_8"></a><img alt="image" class="vertical" src="images/f0008-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap_small">
<p class="image"><a id="page_9"></a><img alt="image" src="images/f0009-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_10"></a><a id="page_11"></a><img alt="image" class="vertical" src="images/f0011-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_12"></a><img alt="image" class="vertical" src="images/f0012-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_13"></a><span class="pink5">I WRITE SO MUCH BECAUSE MY CAT SITS ON MY LAP. SHE PURRS SO I DON’T WANT TO GET UP. SHE’S SO MUCH MORE CALMING THAN MY HUSBAND.</span></p>
<p class="left"><span class="orange">JOYCE CAROL OATES</span></p>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_14"></a><img alt="image" class="vertical" src="images/f0014-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_15"></a><img alt="image" class="vertical" src="images/f0015-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap_small">
<p class="image"><a id="page_16"></a><a id="page_17"></a><img alt="image" src="images/f0017-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap_small">
<p class="image"><a id="page_18"></a><img alt="image" src="images/f0018-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_19"></a><img alt="image" class="vertical" src="images/f0019-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_20"></a><a id="page_21"></a><img alt="image" class="vertical" src="images/f0021-01.jpg"/></p>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_22"></a><img alt="image" class="horizontal" src="images/f0022-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_23"></a><a id="page_24"></a><img alt="image" class="vertical" src="images/f0024-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_25"></a><img alt="image" class="vertical" src="images/f0025-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_26"></a><span class="red">CATS CAN BE VERY FUNNY, AND HAVE THE ODDEST WAYS OF SHOWING THEY’RE GLAD TO SEE YOU. RUDIMACE ALWAYS PEED IN OUR SHOES.</span></p>
<p class="left"><span class="gray">W. H. AUDEN</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_27"></a><img alt="image" class="vertical" src="images/f0027-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_28"></a><img alt="One, please. TICKETS psst, all clear!" class="horizontal" src="images/f0028-01.jpg"/></p>
</div>
<div class="wrap">
<p class="image"><a id="page_29"></a><img alt="ANNE EMOND" class="horizontal" src="images/f0029-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_30"></a><img alt="TRUE-LIFE KITTY KONFESSIONS! I HAVE FIVE DIFFERENT HOMES . . . &amp; TEN DIFFERENT NAMES . . . I WATCH YOU SHOWER. I ATE THE BUDGIE. I LET THE KIDS NEXT DOOR DRESS ME UP IN PRETTY DRESSES I EAT SIXTEEN MEALS A DAY. I PREFER MRS SMITH’S ARMCHAIR. THE DOG AND I ARE IN CAHOOTS. I HATE IT WHEN YOU TALK TO ME IN THAT STUPID VOICE. I READ YOUR DIARY WHEN YOU’RE NOT HOME." class="horizontal" src="images/f0030-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_31"></a><img alt="image" class="vertical" src="images/f0031-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_32"></a><img alt="image" class="vertical" src="images/f0032-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_33"></a><img alt="image" class="vertical" src="images/f0033-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_34"></a><img alt="image" class="vertical" src="images/f0034-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_35"></a><span class="yellow">CATS ARE CONNOISSEURS OF COMFORT.</span></p>
<p class="left"><span class="green">JAMES HERRIOT</span></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_36"></a><a id="page_37"></a><img alt="image" class="vertical" src="images/f0037-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_38"></a><img alt="image" class="vertical" src="images/f0038-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap_small">
<p class="image"><a id="page_39"></a><img alt="image" src="images/f0039-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_40"></a><a id="page_41"></a><img alt="image" class="vertical" src="images/f0041-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_42"></a><a id="page_43"></a><img alt="image" class="vertical" src="images/f0043-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_44"></a><img alt="image" class="horizontal" src="images/f0044-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_45"></a><img alt="image" class="vertical" src="images/f0045-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_46"></a><img alt="image" class="vertical" src="images/f0046-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_47"></a><img alt="image" class="vertical" src="images/f0047-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_48"></a><img alt="image" class="vertical" src="images/f0048-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_49"></a><span class="green1">A CAT IS MORE INTELLIGENT THAN PEOPLE BELIEVE, AND CAN BE TAUGHT ANY CRIME.</span></p>
<p class="left"><span class="brown">MARK TWAIN</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_50"></a><a id="page_51"></a><img alt="image" class="horizontal" src="images/f0050-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_52"></a><img alt="image" class="vertical" src="images/f0052-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_53"></a><img alt="image" class="vertical" src="images/f0053-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_54"></a><img alt="image" class="vertical" src="images/f0054-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_55"></a><span class="gray1">THE TAIL, IN CATS, IS THE PRINCIPAL ORGAN OF EMOTIONAL EXPRESSION.</span></p>
<p class="left"><span class="pink">ALDOUS HUXLEY</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_56"></a><a id="page_57"></a><img alt="image" class="vertical" src="images/f0057-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_58"></a><span class="yellow1">WHAT SORT OF PHILOSOPHERS ARE WE, WHO KNOW ABSOLUTELY NOTHING OF THE ORIGIN AND DESTINY OF CATS?</span></p>
<p class="left"><span class="blue">HENRY DAVID THOREAU</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_59"></a><a id="page_60"></a><img alt="HEART HEAD LIFE" class="vertical" src="images/f0059-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_61"></a><img alt="image" class="vertical" src="images/f0061-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_62"></a><a id="page_63"></a><img alt="6/70 Un aware Jane ormes 2012" class="vertical" src="images/f0063-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_64"></a><img alt="30 CATS" class="vertical" src="images/f0064-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_65"></a><img alt="yoana Roja B." class="vertical" src="images/f0065-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_66"></a><a id="page_67"></a><img alt="image" class="vertical" src="images/f0067-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_68"></a><a id="page_69"></a><img alt="image" class="vertical" src="images/f0069-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_70"></a><span class="red1">IT IS IN THE NATURE OF CATS TO DO A CERTAIN AMOUNT OF UNESCORTED ROAMING.</span></p>
<p class="left">ADLAI E. STEVENSON</p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_71"></a><img alt="image" class="vertical" src="images/f0071-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_72"></a><img alt="image" class="vertical" src="images/f0072-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_73"></a><img alt="image" class="vertical" src="images/f0073-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_74"></a><img alt="image" class="vertical" src="images/f0074-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_75"></a><span class="pink1">IF A FISH IS THE MOVEMENT OF WATER EMBODIED, GIVEN SHAPE, THEN CAT IS A DIAGRAM AND PATTERN OF SUBTLE AIR.</span></p>
<p class="left"><span class="orange">DORIS LESSING</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_76"></a><a id="page_77"></a><img alt="CAT VOCABULARY MIRRAWAP! IK! IK IK IK.* PRRRRRAWWN. MROW? *ABYSSINIAN DIALECT" class="vertical" src="images/f0077-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_78"></a><img alt="image" class="vertical" src="images/f0078-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_79"></a><img alt="image" class="horizontal" src="images/f0079-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_80"></a><a id="page_81"></a><img alt="image" class="vertical" src="images/f0081-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_82"></a><img alt="image" class="vertical" src="images/f0082-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_83"></a><img alt="image" class="vertical" src="images/f0083-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_84"></a><img alt="image" class="vertical" src="images/f0084-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_85"></a><span class="gray2">WHEN I PLAY WITH MY CAT, HOW DO I KNOW THAT SHE IS NOT PASSING TIME WITH ME RATHER THAN I WITH HER?</span></p>
<p class="left"><span class="pink2">MICHEL DE MONTAIGNE</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_86"></a><a id="page_87"></a><img alt="image" class="horizontal" src="images/f0086-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_88"></a><a id="page_89"></a><img alt="albert &amp; marie" class="vertical" src="images/f0089-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_90"></a><img alt="don’t patronise me" class="horizontal" src="images/f0090-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_91"></a><span class="pink3">THE CAT IS ONLY DOMESTIC AS FAR AS IT SUITS ITS OWN ENDS.</span></p>
<p class="left"><span class="gray3">SAKI (H. H. MONROE)</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_92"></a><img alt="image" class="vertical" src="images/f0092-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_93"></a><img alt="image" class="vertical" src="images/f0093-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_94"></a><a id="page_95"></a><img alt="image" class="vertical" src="images/f0095-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_96"></a><img alt="image" class="vertical" src="images/f0096-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_97"></a><span class="gray4">THE CAT DOES NOT OFFER SERVICES. THE CAT OFFERS ITSELF.</span></p>
<p class="left"><span class="pink4">WILLIAM S. BURROUGHS</span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_98"></a><img alt="image" class="vertical" src="images/f0098-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_99"></a><img alt="pussy pussy CAT WHERE YOU BEEN have LIVE BEEN TO LONDON THE QUEEN A WHAT DID YOU DO THERE little MOUSE under I FRIGHTENED A CHAIR" class="vertical" src="images/f0099-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_100"></a><img alt="image" class="horizontal" src="images/f0100-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_101"></a><img alt="image" class="vertical" src="images/f0101-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_102"></a><span class="red2">THE PROBLEM WITH CATS IS THAT THEY GET THE SAME EXACT LOOK WHETHER THEY SEE A MOTH OR AN AXE MURDERER.</span></p>
<p class="left"><strong>PAULA POUNDSTONE</strong></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_103"></a><img alt="image" class="horizontal" src="images/f0103-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_104"></a><a id="page_105"></a><img alt="image" class="horizontal" src="images/f0105-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_106"></a><img alt="image" class="vertical" src="images/f0106-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_107"></a><span class="blue1">HOLDING UP MY PURRING CAT TO THE MOON, I SIGHED.</span></p>
<p class="left"><span class="yellow2"><strong>JACK KEROUAC</strong></span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_108"></a><img alt="image" class="vertical" src="images/f0108-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_109"></a><img alt="image" class="vertical" src="images/f0109-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_110"></a><img alt="image" class="vertical" src="images/f0110-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_111"></a><img alt="image" class="vertical" src="images/f0111-01.jpg"/></p>
</div>
<div class="pagebreak">
<p class="pull_quote"><a id="page_112"></a><span class="gray5">THOSE WHO’LL PLAY WITH CATS MUST EXPECT TO BE SCRATCHED.</span></p>
<p class="left"><span class="green2"><strong>MIGUEL DE CERVANTES</strong></span></p><div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_113"></a><img alt="image" class="vertical" src="images/f0113-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_114"></a><a id="page_115"></a><img alt="I REALLY LIKE YOU." class="vertical" src="images/f0115-01.jpg"/></p>
</div>
<div class="pagebreak">
<div class="wrap">
<p class="image"><a id="page_116"></a><a id="page_117"></a><img alt="HAVE YOU HUGGED YOUR CAT TODAY?" class="horizontal" src="images/f0117-01.jpg"/></p>
</div>
</div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06-chapter01.vue?0db714b8